var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "38px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "48px",
    height: "38px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAQAAAAohNCKAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhUUFSVMWv59AAACHElEQVRIx+1W0XmbMBD+3Y/nog2iCYo6AXiB2l2g0AlMJ6BMYGcC110AOwsIZwFMFhBfJyBZQH04ZERix0Ddh3xf7h7QSaD/9OvuuInkE5D4FT0P7JEBbi1qsvfcXh0uChoaGmo5pwHN+BuykggKGkpjnH5okeKtjcsa//Mp+FjfARwBqtkdDbaCnoH8l22fU6S8nTmSvyHCCnaKsOEKKLdMImNKThve7MnOBNmLeDRA12QF+b8OyA5TsjMxFsCx2fqc1QwAvIcop5ndFwBwn+YH4Ge09/szv/zRhLlBWgesIDrc0vC/iOmGwtQ6XU+VvKFI8q2IYy7bfDBL5oIpB8xtDAbofKZa7zVERv7TBc9uB1F/dHMCdUykKvz9KzEcRunmGzjgPtQeAOQD0y2oOnnglmHaUqMRpoae8fHTUJREmbC31tCYL8324+P/TB5oSN5wf4yeKwJIHqzbaOq7fRyzAuqUcil581LOO6FqFe9LaorLaWUF3LLBs0LM27XB2gPg1XB1Hj926n118ydedv8MPaV6McPbMNXQUFCzW1Pk+qs5QVuRSU3Zd/x73LNaFOIwP4zw+6I4eWibO7H96hWjKDoH0A5zPpUAePL9qifoWPzaBMHuKv6PvAO8A7wBAAcApmsAoKYL2IR9GiyvXK1s+/lX5admoKExrOMhNe3wpf/B27+DawBU55fcJ+fyS69LUM3uqAc/JavFX5XJBLMOjsABAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.3a9e5a95ad947552fe2b49bd5fd9b5d4.svg";
export { ForwardRef as ReactComponent };